import React from 'react';
import { observer } from 'mobx-react';
import { FacilityInventoryCountDetailListTemplate } from 'themes/application/facility-inventory/pages';
import { setCurrentView } from 'core/utils';
import { FacilityInventoryCountDetailListViewStore } from 'application/facility-inventory/stores';

@setCurrentView((rootStore) => new FacilityInventoryCountDetailListViewStore(rootStore), "facilityInventoryCountDetailListViewStore")
@observer
class FacilityInventoryCountDetailList extends React.Component {
    render() {
        return <FacilityInventoryCountDetailListTemplate {...this.props} />
    }
}

export default FacilityInventoryCountDetailList;